/* =========================================================
   EAZY CLOTHES — PUNKTY WERYFIKACJI

   Znaczniki na zdjeciu sterujace jednym panelem. Wzorzec zakladek:
   role="tablist" / "tab" / "tabpanel", roving tabindex, strzalki
   przechodza miedzy punktami.

   Dotyk jest przypadkiem pierwszorzednym: tresc zmienia wylacznie
   klikniecie albo tap. Najechanie myszka nie robi tu nic — podswietlenie
   zalatwia CSS. Dzieki temu telefon i desktop zachowuja sie identycznie
   i nie ma sciezki, ktora istnieje tylko na jednej platformie.

   Bez tego skryptu sekcja zostaje czytelna: CSS pokazuje wtedy wszystkie
   panele jako liste, a znaczniki chowa (patrz regula html:not(.ez-js)).
   ========================================================= */
(function ezVerificationPoints() {
  const init = (root) => {
    const markers = Array.from(root.querySelectorAll('[data-vp-marker]'));
    const panels = Array.from(root.querySelectorAll('[data-vp-panel]'));
    if (markers.length === 0 || panels.length === 0) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const select = (id, { focusMarker = false, reveal = false } = {}) => {
      markers.forEach((marker) => {
        const on = marker.dataset.vpTarget === id;
        marker.setAttribute('aria-selected', on ? 'true' : 'false');
        /* Roving tabindex: w grupie zakladek Tab wchodzi w jeden element,
           a nie w kazdy z osobna. */
        marker.tabIndex = on ? 0 : -1;
        if (on && focusMarker) marker.focus();
      });

      panels.forEach((panel) => {
        panel.classList.toggle('is-active', panel.dataset.vpId === id);
      });

      if (!reveal) return;

      /* Na telefonie panel stoi POD zdjeciem, wiec po tapnieciu moze byc
         ucciety dolna krawedzia ekranu. Dociagamy go tylko wtedy, gdy nie
         miesci sie w calosci — bezwarunkowe przewijanie szarpaloby strona
         przy kazdym tapnieciu.

         NIE przez block: 'nearest'. Zmierzone: przy oknie 844px panel
         zaczyna sie na 689px i konczy na 1110px, czyli gora jest w kadrze,
         a dol poza nim. 'nearest' uznaje wtedy, ze nie ma czego robic,
         i nie przewija ani o piksel — tresc zostaje ucieta.

         'end' dosuwa DOL panelu do dolu okna, czyli przewija o dokladnie
         tyle, ile trzeba, i zostawia na gorze tyle zdjecia, ile sie zmiesci.
         Wyjatek: panel wyzszy od okna nie zmiesci sie tak czy inaczej —
         wtedy 'start', zeby zaczac go czytac od poczatku, a nie od srodka. */
      const panel = panels.find((p) => p.dataset.vpId === id);
      if (!panel) return;
      const box = panel.getBoundingClientRect();
      const miesciSie = box.top >= 0 && box.bottom <= window.innerHeight;
      if (miesciSie) return;
      panel.scrollIntoView({
        block: box.height > window.innerHeight ? 'start' : 'end',
        behavior: reduceMotion ? 'auto' : 'smooth',
      });
    };

    markers.forEach((marker) => {
      marker.addEventListener('click', () => {
        select(marker.dataset.vpTarget, { reveal: true });
      });
    });

    root.addEventListener('keydown', (event) => {
      const aktywny = markers.findIndex((m) => m.getAttribute('aria-selected') === 'true');
      if (aktywny === -1) return;

      let cel = null;
      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
        cel = (aktywny + 1) % markers.length;
      } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
        cel = (aktywny - 1 + markers.length) % markers.length;
      } else if (event.key === 'Home') {
        cel = 0;
      } else if (event.key === 'End') {
        cel = markers.length - 1;
      }

      if (cel === null) return;
      event.preventDefault();
      select(markers[cel].dataset.vpTarget, { focusMarker: true });
    });
  };

  const initAll = (scope) => {
    scope.querySelectorAll('[data-vp]').forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document), { once: true });
  } else {
    initAll(document);
  }

  /* Edytor motywu przeladowuje pojedyncze sekcje bez odswiezania strony. */
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target instanceof HTMLElement) initAll(event.target);
  });
})();
